<template>
  <div>
    <v-select
      v-show="isMobile"
      v-model="active[0]"
      :items="foldersFormattedForMobile"
      item-text="name"
      item-value="id"
      return-object
      solo
      outlined
      dense
      prepend-inner-icon="mdi-folder-open-outline"
    >
      <template v-slot:item="{ item }">
        <span :class="item.styleRule ? 'font-weight-bold' : null">{{
          item.name
        }}</span
        ><v-badge
          :content="item.badgeContent"
          :value="Boolean(item.badgeContent)"
          color="error"
          inline
        ></v-badge>
      </template>
    </v-select>
    <v-row>
      <v-col v-show="!isMobile" cols="12" sm="3">
        <v-treeview
          :items="folders"
          :active.sync="active"
          :open.sync="open"
          activatable
          open-on-click
          return-object
        >
          <template v-slot:prepend="{ item }">
            <v-icon v-if="!item.children">
              {{
                active[0] && active[0].id === item.id
                  ? "mdi-folder-open-outline"
                  : "mdi-folder-outline"
              }}
            </v-icon>
          </template>
          <template v-slot:label="{ item }">
            <span :class="item.styleRule ? 'font-weight-medium' : null">{{
              item.name
            }}</span
            ><v-badge
              :content="item.badgeContent"
              :value="Boolean(item.badgeContent)"
              color="error"
              bordered
            ></v-badge
            ><export-chart-button
              v-if="
                isAdmin &&
                Boolean(client) &&
                item.name === 'Underschool' &&
                item.children
              "
              :clientId="client.clientId"
              :clientName="client.fullName"
            ></export-chart-button>
            </template></v-treeview
      ></v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="9">
        <component
          v-if="active.length > 0"
          :is="active[0].component"
          :clientId="Boolean(client) ? client.clientId : null"
          :isServiceCoordination="active[0].name == 'SC Notes'"
          :notes="
            active[0].name == 'SC Notes'
              ? serviceCoordinationNotes
              : active[0].name == 'Session Notes'
              ? sessionNotes
              : null
          "
          :ageCategory="active[0].ageCategory"
          :headers="active[0].headers"
          :items="active[0].items"
          :zipFileName="active[0].zipFileName"
          :key="active[0].id"
      /></v-col>
    </v-row>
  </div>
</template>

<script>
import NotesTable from "./notes-table";
import GapsInService from "./gaps-in-service";
import OtherDocuments from "./other-documents.vue";
import DocumentsTable from "./documents-table";
import ExportChartButton from "./export-chart-button";

export default {
  props: ["client"],
  data() {
    return {
      active: [],
      open: [],
      progressReportHeaders: [
        {
          text: "File Name",
          value: "fileName",
        },
        {
          text: "Provider Name",
          value: "providerName",
        },
        {
          text: "Service",
          value: "service",
        },
        {
          text: "Report Type",
          value: "reportTypeName",
        },
        {
          text: "Due Date",
          value: "formattedDueDate",
        },
      ],
      inPersonLogHeaders: [
        {
          text: "Provider",
          value: "providerName",
        },
        {
          text: "Service",
          value: "service",
        },
        {
          text: "Pay Period Start",
          value: "formattedPayPeriodStart",
        },
        {
          text: "Pay Period End",
          value: "formattedPayPeriodEnd",
        },
      ],
      evaluationDocumentHeaders: [
        {
          text: "Document Name",
          value: "documentName",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: "Date Received",
          value: "formattedDateReceived",
        },
      ],
      assessmentHeaders: [
        {
          text: "File",
          value: "fileName",
        },
        {
          text: "Assessment Date",
          value: "formattedAssessmentDate",
        },
      ],
    };
  },
  components: {
    NotesTable,
    GapsInService,
    OtherDocuments,
    DocumentsTable,
    ExportChartButton,
  },
  mounted() {
    var folder = this.folders.find(
      (item) => item.name == this.client?.currentAgeCategory
    );
    if (Boolean(folder)) {
      this.open.push(folder);
      this.active.push(folder.children[0]);
    } else {
      this.open.push(this.folders[0]);
      this.active.push(this.folders[0].children[0]);
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    folders() {
      var folders = [
        {
          id: 0,
          name: "Underschool",
          children: [
            {
              id: 1,
              name: "SC Notes",
              showTab: !this.isProvider, //SEITAdmin/EIAdmin/ServiceCoordinator can always view
              styleRule: Boolean(this.serviceCoordinationNotes.length),
              badgeContent: this.numAwaitingSCSignature,
              component: "NotesTable",
            },
            {
              id: 2,
              name: "Session Notes",
              showTab: this.isEIAdmin || Boolean(this.client), // EIAdmin can always view and anyone can view when within Client Chart
              styleRule: Boolean(this.sessionNotes.length),
              badgeContent: this.numAwaitingSupervisorSignature,
              component: "NotesTable",
            },
            {
              id: 3,
              name: "Gaps in Service",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.gapsInService.length),
              badgeContent: null,
              component: "GapsInService",
            },
            {
              id: 4,
              name: "Progress Reports",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.progressReports("Underschool").length),
              badgeContent: null,
              component: "DocumentsTable",
              ageCategory: "Underschool",
              headers: this.progressReportHeaders,
              items: this.progressReports("Underschool"),
              zipFileName: `${this.client?.fullName} Progress Reports.zip`,
            },
            {
              id: 5,
              name: "In Person Logs",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.inPersonLogs.length),
              badgeContent: null,
              component: "DocumentsTable",
              headers: this.inPersonLogHeaders,
              items: this.inPersonLogs,
              zipFileName: `${this.client?.fullName} In Person Logs.zip`,
            },
            {
              id: 6,
              name: "Other Documents",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.documents("Underschool").length),
              badgeContent: null,
              component: "OtherDocuments",
              ageCategory: "Underschool",
            },
          ],
        },
        {
          id: 7,
          name: "Preschool",
          children: [
            {
              id: 8,
              name: "CEV Documents",
              showTab: !this.isProvider && Boolean(this.client), //SEITAdmin/EIAdmin/ServiceCoordinator can view when within Client Chart
              styleRule: Boolean(this.evaluationDocuments.length),
              badgeContent: null,
              component: "DocumentsTable",
              ageCategory: "Preschool",
              headers: this.evaluationDocumentHeaders,
              items: this.evaluationDocuments,
              zipFileName: `${this.client?.fullName} CEV Documents.zip`,
            },
            {
              id: 9,
              name: "CEV Assessments",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.assessments.length),
              badgeContent: null,
              component: "DocumentsTable",
              ageCategory: "Preschool",
              headers: this.assessmentHeaders,
              items: this.assessments,
              zipFileName: `${this.client?.fullName} Assessments.zip`,
            },
            {
              id: 10,
              name: "Progress Reports",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.progressReports("Preschool").length),
              badgeContent: null,
              component: "DocumentsTable",
              ageCategory: "Preschool",
              headers: this.progressReportHeaders,
              items: this.progressReports("Preschool"),
              zipFileName: `${this.client?.fullName} Progress Reports.zip`,
            },
            {
              id: 11,
              name: "Other Documents",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.documents("Preschool").length),
              badgeContent: null,
              component: "OtherDocuments",
              ageCategory: "Preschool",
            },
          ],
        },
        {
          id: 12,
          name: "SchoolAge",
          children: [
            {
              id: 13,
              name: "Other Documents",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.documents("SchoolAge").length),
              badgeContent: null,
              component: "OtherDocuments",
              ageCategory: "SchoolAge",
            },
          ],
        },
      ];
      return folders
        .map((parent) => ({
          ...parent,
          children: parent.children.filter((child) => child.showTab),
        }))
        .filter((parent) => parent.children.length > 0);
    },
    foldersFormattedForMobile() {
      var array = [];
      this.folders.map((x) => {
        array.push({ header: x.name });
        array.push(...x.children);
      });
      return array;
    },
    serviceCoordinationNotes() {
      return this.$store.state.clientModule.serviceCoordinationNotes;
    },
    sessionNotes() {
      return this.$store.state.clientModule.sessionNotes;
    },
    gapsInService() {
      return this.$store.state.clientModule.gapsInService ?? [];
    },
    inPersonLogs() {
      return this.$store.state.clientModule.inPersonLogs ?? [];
    },
    evaluationDocuments() {
      return this.$store.state.clientModule.evaluationDocuments ?? [];
    },
    assessments() {
      return this.$store.state.clientModule.assessments;
    },
    numAwaitingSCSignature() {
      return this.serviceCoordinationNotes.filter(
        (item) => item.providerId === this.providerId && !item.scSignatureId
      ).length;
    },
    numAwaitingSupervisorSignature() {
      return this.sessionNotes.filter(
        (item) =>
          item.supervisorId === this.providerId && !item.supervisorSignatureId
      ).length;
    },
    isEIAdmin() {
      return this.$store.getters["securityModule/isEIAdmin"];
    },
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    providerId() {
      return this.$store.state.sharedModule.providerId;
    },
  },
  methods: {
    progressReports(ageCategory) {
      return this.$store.getters[
        "clientModule/getProgressReportsForAgeCategory"
      ](ageCategory);
    },
    documents(ageCategory) {
      return this.$store.getters["clientModule/getDocumentsForAgeCategory"](
        ageCategory
      );
    },
  },
};
</script>